import isEmpty from "lodash/isEmpty"
import merge from "lodash/merge"
import keyBy from "lodash/keyBy"
import { compose, withPropsOnChange } from "recompose"
import { getMts } from "../../../api/entities/actualMts"
import withApiTransport from "../../../api/apiTransport"

const enhance = compose(
  withPropsOnChange([`issue`], ({ issue: { id } = {} }) => ({
    load: getMts,
    propName: `actualMts`,
    payload: id,
  })),
  withApiTransport,
  withPropsOnChange(
    [`plannedMts`, `actualMts`],
    ({ plannedMts, actualMts }) => {
      if (isEmpty(plannedMts) && isEmpty(actualMts)) {
        return {}
      }
      const preparedMts = merge(keyBy(plannedMts, `materialNumber`), actualMts)
      return { preparedMts }
    },
  ),
)

export default enhance
